<template>
  <div>
    <px-view-header title="Cadastro de categoria"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingGrupo">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição da categoria"
            :error="$v.grupo.descricao.$error"
            @blur="$v.grupo.descricao.$touch()"
            v-model="grupo.descricao"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código interno da categoria"
            v-model="grupo.codigo"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <px-autocomplete-grupo
            dense
            label="Categoria pai"
            class="rounded-tag-small"
            v-model="grupo.grupoPai"/>
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import AutocompleteGrupo from '@/components/PxAutocompleteGrupo.vue';
import GruposService from './grupos-service';


export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingGrupo: false,
      grupo: {
        descricao: null,
        codigo: null,
        grupoPai: null,
      },
      grupoId: this.$route.params.id,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Categorias' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.grupos' });
    },
    getGrupo() {
      this.loadingGrupo = true;
      GruposService.get(this.grupoId)
        .then((response) => {
          this.grupo = response.data;
        })
        .finally(() => {
          this.loadingGrupo = false;
        });
    },
    buildPayload() {
      const grupo = { ...this.grupo };
      grupo.descricao = this.grupo.descricao.trim();
      if (this.grupo.codigo) {
        grupo.codigo = this.grupo.codigo.trim();
      }
      if (this.grupo.grupoPai === undefined) {
        grupo.grupoPai = null;
      }
      return grupo;
    },
    salvar() {
      this.loading = true;
      GruposService.save(this.buildPayload())
        .then(() => {
          if (this.grupoId) {
            this.$toast('Categoria atualizada com sucesso', { color: 'success' });
          } else {
            this.$toast('Categoria criada com sucesso', { color: 'success' });
          }
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.grupoId) {
      this.getGrupo();
    }
  },
  validations: {
    grupo: {
      descricao: {
        required,
      },
    },
  },
  components: { PxAutocompleteGrupo: AutocompleteGrupo },
};
</script>
